import { store } from "react-notifications-component";

const defaultModel = {
    title: "",
    showIcon: true,
    message: "",
    type: "",
    insert: "top",
    container: "top-center",
    animationIn: ["animated", "fadeIn"],
    animationOut: ["animated", "fadeOut"],
    dismiss: {
        duration: 3000,
        onScreen: true,
    },
}

const error = (message) => {
    store.addNotification({
        ...defaultModel,
        message: message ? message : "error",
        title: "Error",
        type: "danger"
    });
}

const success = (message) => {
    store.addNotification({
        ...defaultModel,
        message: message ? message : "success",
        title: "success",
        type: "success"
    });
}

const warning = (message) => {
    store.addNotification({
        ...defaultModel,
        message: message ? message : "warning",
        title: "Warning",
        type: "warning"
    });
}

const info = (message) => {
    store.addNotification({
        ...defaultModel,
        message: message ? message : "info",
        title: "Info",
        type: "info"
    });
}

export default { error, success, warning, info };